import styled from 'styled-components';
import { getSpace } from '../../../foundation/theme/space.utils';
import tokens from '../../../foundation/tokens/js/tokens';
// styled-components.
// -----------------------------------------------------------------------------
export const BaseTableEmptyIcon = styled.div `
  color: ${tokens.colors.midnight[300].value};

  svg {
    height: 48px;
    width: 48px;
  }
`;
export const BaseTableNoDataRoot = styled.tr ``;
export const BaseTableNoDataTitle = styled.div `
  color: ${tokens.colors.midnight[500].value};
  text-transform: uppercase;
`;
export const BaseTableNoDataWrapper = styled.div `
  // Box.
  align-items: center;
  display: flex;
  flex-direction: column;

  // Spacing.
  gap: ${getSpace('xl')};
  margin: ${getSpace('5xl')};
`;
//# sourceMappingURL=BaseTableNoData.styled.js.map